import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { SimpleImage } from '$partials/media';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ProfileCardsBlock}
 */
const ProfileCards = ({
    id,
    backgroundColor,
    profiles,
}) => {
    const { page } = usePage();
    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`${bgColor} col-wrapper-breakout rounded-lg py-24`}>
            <div className='flex flex-wrap gap-y-8 md:gap-y-16'>
                {profiles.map((profile, idx) => {
                    return (
                        <div
                            className='col-padding w-full sm:w-6/12 md:w-4/12'
                            key={profile.id}>
                            <div className='h-full bg-surface-raised p-16 rounded-lg'>

                                {profile.mediaAsset?.image && (
                                    <figure className='rounded-lg overflow-hidden'>
                                        <SimpleImage
                                            {...profile.mediaAsset?.image}
                                            className='h-full w-full object-cover object-center' />
                                    </figure>
                                )}

                                <p className='type-style-sans-h3-med mt-16 md:mt-24'>
                                    {profile.title}
                                </p>

                                {profile.bio && (
                                    <div
                                        className='type-style-sans-body mt-8'
                                        dangerouslySetInnerHTML={{
                                            __html: profile.bio
                                        }} />
                                )}

                                {profile.linkedinUrl && (
                                    <Button
                                        as='a'
                                        className='mt-16 button-outcome'
                                        data-analytics-action='click'
                                        data-analytics-context={profile.title}
                                        data-analytics-destination={formatLinkBlockToUrl(profile.linkedinUrl)}
                                        data-analytics-id={`${page?.id}_${id}_partnership_cards_cta_${idx}`}
                                        data-analytics-label={'LinkedIn'}
                                        data-analytics-location='modules'
                                        data-analytics-module='profile_cards_linkedin'
                                        href={formatLinkBlockToUrl(profile.linkedinUrl)}>
                                        {'LinkedIn'}
                                    </Button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ProfileCards;
